export const payload = {
  weight: "",
  color: "",
  saturation: "",
  shape: "",
  clarity: "",
  fluorescence: "",
  depth: "",
  polish: "",
  symmetry: "",
  ratio: "",
  colorInnerGrade: "",
  colorDispersion: "",
  colorUndertone: "",
  singlePair: "",
};


export const shapes = {
  Radiant: [
    { text: '1', value: '1.00', upto: '1.09' },
    { text: '2', value: '1.10', upto: '1.19' },
    { text: '3', value: '1.20', upto: '1.29' },
    { text: '4', value: '1.30', upto: '1.30 +' },
  ],
  Pear: [
    { text: '1', value: '1.30', upto: '1.39' },
    { text: '2', value: '1.40', upto: '1.49' },
    { text: '3', value: '1.50', upto: '1.59' },
    { text: '4', value: '1.60', upto: '1.60 +' },
  ],
  Oval: [
    { text: '1', value: '1.20', upto: '1.29' },
    { text: '2', value: '1.30', upto: '1.39' },
    { text: '3', value: '1.40', upto: '1.44' },
    { text: '4', value: '1.45', upto: '1.45 +' },
  ],
  Cushion: [
    { text: '1', value: '1.00', upto: '1.09' },
    { text: '2', value: '1.10', upto: '1.19' },
    { text: '3', value: '1.20', upto: '1.29' },
    { text: '4', value: '1.30', upto: '1.30 +' },
  ],
  Round: [{ text: '1', value: '1.00', upto: '1.00' }],
  Heart: [
    { text: '1', value: '0.95', upto: '0.99' },
    { text: '2', value: '1.00', upto: '1.04' },
    { text: '3', value: '1.05', upto: '1.05 +' },
  ],
  Emerald: [
    { text: '1', value: '1.00', upto: '1.19' },
    { text: '2', value: '1.20', upto: '1.29' },
    { text: '3', value: '1.30', upto: '1.39' },
    { text: '4', value: '1.40', upto: '1.40 +' },
  ],
};